import { useTranslation } from 'react-i18next';
import logo from '../../../assets/zaddons_logo.png';
import './NotMobileSupported.scss';

const NotMobileSupported = () => {
    const { t } = useTranslation('common', { keyPrefix: 'notMobileSupported' });

    return (
        <div className="not-mobile-supported">
            <div className="content">
                <img
                    src={logo}
                    alt=""
                    width="200px"
                    height="40px"
                    className="block-center img-rounded"
                    style={{ objectFit: 'cover' }}
                />
                <p className="lead m0">{t('title')}</p>
                <p>{t('subTitle')}</p>
            </div>
        </div>
    );
};

export default NotMobileSupported;
